import { cn } from '../lib/cn.js';
import { initials as toInitials } from '../format.js';

export interface AvatarProps {
  /** Display name; initials are derived from it. */
  name: string;
  /** Override the derived initials. */
  initials?: string;
  /** Diameter in px. Default 28 (h-7 w-7). */
  size?: 20 | 24 | 28 | 32 | 40;
  className?: string;
}

const FONT: Record<NonNullable<AvatarProps['size']>, string> = {
  20: 'text-[9px]',
  24: 'text-[10px]',
  28: 'text-2xs',
  32: 'text-xs-plus',
  40: 'text-nav',
};

/** Brand-red circle with white initials. Never a photograph (DESIGN_SYSTEM section 6.6). */
export function Avatar({ name, initials, size = 28, className }: AvatarProps) {
  return (
    <span
      role="img"
      aria-label={name}
      style={{ width: size, height: size }}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-brand font-medium text-white',
        FONT[size],
        className,
      )}
    >
      {initials ?? toInitials(name)}
    </span>
  );
}
